import SystemInitPage from "../pages/admin/system/SystemInitPage";
import LoginPage from "../pages/LoginPage";
import {TableOutlined} from "@ant-design/icons";
import ReligionVenueListPage from "../pages/admin/religion/ReligionVenueListPage";
import ReligionVenueEditPage from "../pages/admin/religion/ReligionVenueEditPage";
import TiandyCameraServerListPage from "../pages/admin/camera/TiandyCameraServerListPage";
import OrganizationPage from "../pages/oa/OrganizationPage";
import MemberPage from "../pages/oa/MemberPage";
import NewsPage from "../pages/news/NewsPage";
import NewsCenterPage from "../pages/news/NewsCenterPage";

export const commonRouters = {
    loginTemplateRouters: [
        {
            name: "系统初始化",
            isPrivate: true,
            isPublic: true,
            path: '/login/init',
            hidden: true,
            component: <SystemInitPage/>
        },
        {
            name: "登录",
            isPrivate: true,
            isPublic: true,
            path: "/login",
            hidden: true,
            component: <LoginPage/>
        },
    ],


    mainTemplateRouters: [

        // {
        //     name: "任务管理",
        //     children: [
        //         {
        //             name: "我的任务",
        //             isPrivate: true,
        //             isPublic: true,
        //             path: '/task',
        //             component: <TiandyCameraServerListPage/>
        //         },
        //         {
        //             name: "任务发布",
        //             isPrivate: true,
        //             isPublic: true,
        //             path: '/task/publish',
        //             component: <TiandyCameraServerListPage/>
        //         },
        //     ]
        // },
        // {
        //     name: "组织与成员",
        //     children: [
        //         {
        //             name: "组织架构",
        //             isPrivate: true,
        //             isPublic: true,
        //             path: '/organization',
        //             component: <OrganizationPage/>
        //         },
        //         {
        //             name: "组织架构编辑",
        //             isPrivate: true,
        //             isPublic: true,
        //             hidden: true,
        //             path: '/organization/edit',
        //             component: <TiandyCameraServerListPage/>
        //         },
        //         {
        //             name: "成员",
        //             isPrivate: true,
        //             isPublic: true,
        //             path: '/member',
        //             component: <MemberPage/>
        //         },
        //         {
        //             name: "成员编辑",
        //             isPrivate: true,
        //             isPublic: true,
        //             hidden: true,
        //             path: '/member/edit',
        //             component: <TiandyCameraServerListPage/>
        //         },
        //     ]
        // },
        {
            name: "宗教场所管理",
            isPrivate: true,
            isPublic: true,
            path: "/religion_venue",
            auth: "religion_venue",
            icon: <TableOutlined/>,
            component: <ReligionVenueListPage/>
        },
        {
            name: "宗教场所编辑",
            isPrivate: true,
            isPublic: true,
            path: "/religion_venue/edit",
            auth: "religion_venue",
            hidden: true,
            component: <ReligionVenueEditPage/>
        },
    ]
}